import { render, staticRenderFns } from "./cModalProcInvasivosNew.vue?vue&type=template&id=1dfd47f8&scoped=true"
import script from "./cModalProcInvasivosNew.vue?vue&type=script&lang=js"
export * from "./cModalProcInvasivosNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd47f8",
  null
  
)

export default component.exports